import { render, staticRenderFns } from "./RateCard.vue?vue&type=template&id=527a4532&scoped=true"
import script from "./RateCard.vue?vue&type=script&lang=js"
export * from "./RateCard.vue?vue&type=script&lang=js"
import style0 from "./RateCard.vue?vue&type=style&index=0&id=527a4532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a4532",
  null
  
)

export default component.exports